<template>
  <div name="modal" class="modal modal-mask" id="simpleModal" tabindex="-1" ref="simpleModal" style="display: block" aria-labelledby="simpleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ modalTitle }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click='closeSimpleModal()'>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ modalBody }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal" @click='closeSimpleModal()'>Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleModal',

  data () {
    return {
    }
  },

  props: ['modalTitle', 'modalBody'],

  methods: {
    closeSimpleModal () {
      this.$emit('statusSimpleModal', false)
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/SimpleModal.vue